import { useState } from "react"
import { RiAddLine, RiSubtractLine } from "@remixicon/react"

export default function CharlestonFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  const faqs = [
    {
      question: "How much does digital marketing cost?",
      answer: "We specialize in working with small businesses and pride ourselves on offering affordable solutions that won't break the bank. Unlike larger agencies, we understand budget constraints and create customized packages that deliver maximum value without the enterprise price tag. Our flexible pricing is designed specifically to accommodate small businesses. That's what truly sets us apart. During your free consultation, we'll create a proposal that fits your budget and delivers real results.",
    },
    {
      question: "How long does it take to see results from SEO?",
      answer: "For local Charleston SEO, you can typically start seeing improvements in 3 to 6 months. We focus on local search optimization first, which often shows faster results. You'll see your Google Business Profile ranking improve, more local traffic, and increased inquiries. We provide monthly reports so you can track your progress every step of the way.",
    },
    {
      question: "Do you work with businesses outside of Charleston?",
      answer: "While we're based in Charleston and specialize in helping local businesses, we work with clients throughout South Carolina and beyond. Our deep understanding of the Charleston market gives our local clients a unique advantage, but our digital marketing expertise translates to any location.",
    },
    {
      question: "What makes your agency different from others?",
      answer: "We're a local Charleston business focused exclusively on helping other small businesses succeed. Unlike large agencies that treat you like a number, you'll work directly with our team. We combine local market expertise with cutting edge digital marketing strategies, and we're genuinely invested in seeing Charleston businesses thrive.",
    },
    {
      question: "Can you help if we already have a website?",
      answer: "Absolutely! We can optimize your existing website for better performance, SEO, and conversions. We'll conduct a comprehensive audit during your free consultation and recommend improvements. Whether you need a full redesign or just some updates, we'll create a solution that works for your business and budget.",
    },
    {
      question: "Do you require long-term contracts?",
      answer: "We offer flexible contract options. While we recommend at least 6 months for digital marketing to show its full potential, we don't lock you into long term contracts. Our goal is to deliver such great results that you'll want to continue working with us. Most of our clients stay with us for years because they see the value we provide.",
    },
    {
      question: "What industries do you specialize in?",
      answer: "We work with a wide variety of Charleston small businesses including restaurants, retail shops, professional services, healthcare providers, home services, real estate, hospitality, and more. Our strategies are customized to each industry's unique needs and the Charleston market's characteristics.",
    },
    {
      question: "How involved will I need to be?",
      answer: "It depends on how involved you want to be! We're here to help you implement your vision, your way. Some clients prefer a hands on approach, while others want us to handle everything. We adapt to your working style and ensure you're never overwhelmed. If you're results driven and want to focus on running your business, we'll manage the details and keep you informed with regular updates. Your level of involvement is completely up to you.",
    },
  ]

  return (
    <section
      aria-label="Frequently Asked Questions"
      id="faq"
      className="relative mx-auto max-w-4xl px-4 scroll-my-24"
    >
      <div className="text-center mb-16">
        <h2 className="relative inline-block text-lg font-semibold tracking-tight text-[#003566]">
          FAQ
          <div className="absolute top-1 -left-[8px] h-5 w-[3px] rounded-r-sm bg-[#003566]" />
        </h2>
        <p className="mt-4 text-4xl font-semibold tracking-tighter text-balance text-gray-900 md:text-5xl">
          Common Questions
        </p>
        <p className="mt-4 text-lg text-balance text-gray-700">
          Everything you need to know about working with us
        </p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden transition-all duration-200 hover:shadow-md"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between p-6 text-left transition-colors hover:bg-gray-50"
              aria-expanded={openIndex === index}
            >
              <span className="text-lg font-semibold text-gray-900 pr-8">
                {faq.question}
              </span>
              <div className="flex-shrink-0">
                {openIndex === index ? (
                  <RiSubtractLine className="size-6 text-[#003566]" />
                ) : (
                  <RiAddLine className="size-6 text-gray-400" />
                )}
              </div>
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openIndex === index ? "max-h-96" : "max-h-0"
              }`}
            >
              <div className="px-6 pb-6 text-gray-600 leading-relaxed">
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center rounded-2xl bg-gray-50 border border-gray-200 p-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Still have questions?
        </h3>
        <p className="text-gray-600 mb-6">
          We're here to help! Schedule a free consultation and we'll answer all your questions.
        </p>
        <a
          href="https://airtable.com/appR9wgPnwfYKJA5f/pagEhOnZkUUuOZskP/form"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex cursor-pointer items-center justify-center rounded-md border-b-[1.5px] border-[#0ea5e9] bg-gradient-to-b from-[#06b6d4] to-[#0ea5e9] px-6 py-3 font-medium text-white shadow-[0_0_0_2px_rgba(14,165,233,0.1),0_0_20px_0_rgba(14,165,233,0.4)] transition-all duration-200 ease-in-out hover:shadow-[0_0_0_2px_rgba(14,165,233,0.15),0_0_28px_0_rgba(14,165,233,0.6)] hover:scale-105"
        >
          Get Your Free Consultation
        </a>
      </div>
    </section>
  )
}
